import React, { useEffect, useState } from 'react';
import '../Login/style.sass'
import { useToken } from 'pages/Header/Content/hooks/useToken'
import { useLoginSSO } from 'pages/Header/Content/hooks/useLogin';
import { useIsMobile } from 'pages/Header/Content/hooks/useIsMobile';
import { decodeStorage, encodeStorage, removeStorage } from 'pages/Header/Content/functions/storageBase64';
import { getTokenSSO } from 'pages/Header/Content/services/SSO'
import { ErrorBoundary } from 'components/Error/ErrorBoundary'

import { Header } from 'pages/Header'
import Loading from 'components/Loading';


export default function Authenticated() {

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Authenticated');
        window.scrollTo(0, 0);
    }, [])

    const { isMobile } = useIsMobile();
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (isMobile) {
            if (isMobile === 'desktop') {
                document.querySelector('#root').classList.add('desktopView')
            }
            else{
                document.querySelector('#root').classList.add('loginHeaderMobile')
            }
        }
    }, [isMobile])

    console.log('asdasda: 1')

    return(
        <>
            { loading && 
				<ErrorBoundary>
					<Loading />
				</ErrorBoundary> 
			}

            <ErrorBoundary>
                <Header type='simple' pageClass="loginHeader" />
            </ErrorBoundary>

            <AuthenticatedSSO  setLoading={setLoading}/>

        </>
    )
}



export function AuthenticatedSSO(props) {
    const {
        setLoading
    } = props

    console.log('asdasdasdads')

    const { dataLogin, reciveRedirect } = useLoginSSO()

    return(
        <main></main>
    )
}